<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                    <kt-form-section >
                        <kt-form-row>
                            <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                    <kt-form-label for="full_name">
                                        {{ $t('label.user_full_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="full_name"
                                            dir="ltr"
                                            name="full_name"
                                            id="full_name"
                                            v-model="query.full_name"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                    <kt-form-label for="phone">
                                        {{ $t('label.phone_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="phone"
                                            name="phone"
                                            id="phone"
                                            v-model="query.phone"
                                            dir="ltr"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                    <kt-form-label for="gateway_status">
                                        {{ $t('label.gateway_status') }}
                                    </kt-form-label>
                                    <kt-form-select
                                            size="3"
                                            id="gateway_status"
                                            class="form-control"
                                            name="gateway_status"
                                            v-model="query.gateway_status"
                                    >
                                        <option
                                                v-bind:key="index"
                                                v-for="(gateway_status, index) in gateway_statuses"
                                                v-bind:value="gateway_status.value"
                                                :selected="query.gateway_status === gateway_status.value"
                                        >
                                            {{ gateway_status.name }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                        <kt-form-row>
                            <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                    <kt-form-label for="subcategory_code">
                                        {{ $t('label.subcategory_code') }}
                                    </kt-form-label>
                                    <select
                                            id="subcategory_code"
                                            name="subcategory_code"
                                            v-model="query.subcategory_code"
                                            class="form-control kt-selectpicker"
                                    >
                                        <option
                                                v-bind:key="subcategory.key"
                                                v-for="subcategory in subcategories"

                                                :value="subcategory.key"
                                        >
                                            {{ subcategory.value }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                    <kt-form-label for="terminal_number">
                                        {{ $t('label.terminal_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="terminal_number"
                                            dir="ltr"
                                            name="terminal_number"
                                            id="terminal_number"
                                            v-model="query.terminal_number"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                    <kt-form-label for="merchant_number">
                                        {{ $t('label.merchant_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            ref="merchant_number"
                                            dir="ltr"
                                            name="merchant_number"
                                            id="merchant_number"
                                            v-model="query.merchant_number"
                                    />
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                    <kt-form-section>
                        <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                    </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { gatewayStatusStr, gatewayStatus } from '@/constants/gatewayStatus'
import {subcategories} from '@/constants/subcategoriesForSearch'
import $ from "jquery";
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    data() {
        return {
            subcategories: subcategories,
            gateway_statuses: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: gatewayStatusStr.ACTIVE,
                    value: gatewayStatus.ACTIVE
                },
                {
                    name: gatewayStatusStr.PENDING,
                    value: gatewayStatus.PENDING
                },
                {
                    name: gatewayStatusStr.SEND_TO_SHAPARAK,
                    value: gatewayStatus.SEND_TO_SHAPARAK
                },
                {
                    name: gatewayStatusStr.REJECTED,
                    value: gatewayStatus.REJECTED
                },
                {
                    name: gatewayStatusStr.BLOCKED,
                    value: gatewayStatus.BLOCKED
                },
                {
                    name: gatewayStatusStr.REJECTED_BY_SHAPARAK,
                    value: gatewayStatus.REJECTED_BY_SHAPARAK
                },
                {
                    name: gatewayStatusStr.ENAMAD_AUTHENTICATED,
                    value: gatewayStatus.ENAMAD_AUTHENTICATED
                },
            ],
            query: {
                gateway_status: null
            },
        }
    }
}
</script>

<style>

</style>